/**
 * Get the customer facing manufacturer name from the originalManufacturerName string
 * @param {string} originalManufacturerName
 */
export default function(originalManufacturerName = '') {
    originalManufacturerName = originalManufacturerName.toLowerCase().trim();
    if (originalManufacturerName == 'peugeot') {
        return 'Peugeot';
    }
    if (originalManufacturerName == 'citroen') {
        return 'Citroën';
    }
    if (originalManufacturerName == 'citroen') {
        return 'Citroën';
    }
    if (originalManufacturerName == 'vauxhall') {
        return 'Vauxhall';
    }
    if (originalManufacturerName == 'ds') {
        return 'DS Automobiles';
    }
    if (originalManufacturerName == 'ds-automobiles') {
        return 'DS Automobiles';
    }
    if (originalManufacturerName == 'ds automobiles') {
        return 'DS Automobiles';
    }
    if (originalManufacturerName == 'fiat') {
        return 'Fiat';
    }
    if (originalManufacturerName == 'abarth') {
        return 'Abarth';
    }
    if (originalManufacturerName == 'jeep') {
        return 'Jeep';
    }
    if (originalManufacturerName == 'alfa') {
        return 'Alfa Romeo';
    }
    if (originalManufacturerName == 'alfa romeo') {
        return 'Alfa Romeo';
    }
    if (originalManufacturerName == 'alfa-romeo') {
        return 'Alfa Romeo';
    }
    if (originalManufacturerName == 'leapmotor') {
        return 'Leapmotor';
    }

    // Return the originalManufacturerName with the first letter capitalised if we don't have a nicer version, with the rest lower case
    if (originalManufacturerName.length > 0) {
        return originalManufacturerName.charAt(0).toUpperCase() + originalManufacturerName.slice(1);
    }

    return 'Stellantis &You UK';
}